import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { BankAccountRepositoryBase } from '@skylab-shared/business';
export { BankAccountRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(BankAccountRepositoryBase)
export class BankAccountRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
    ) { }
}
